import { computed } from '@angular/core';
import { IGtmDataConfig, IGtmDataData, IGtmDataModel } from '@business/api';
import { signalStore, signalStoreFeature, withComputed } from '@ngrx/signals';
import { withDomainState } from '../common';
import { defaultDomainState, defaultDomainStateConfig } from '../functions';
import { IDomainState, IStateConfig } from '../model';

export interface IGtmDataState extends IDomainState<IGtmDataModel, IGtmDataData, IGtmDataConfig> {}

const initialGtmDataState: IGtmDataState = defaultDomainState();
const gtmDataStateConfig: IStateConfig = defaultDomainStateConfig({ storeIdentifier: 'gtm-data' });

export const GtmDataStore = signalStore({ providedIn: 'root' }, withBaseGtmDataStore(initialGtmDataState, gtmDataStateConfig));

function withBaseGtmDataStore(initialState: IGtmDataState, stateConfig: IStateConfig) {
  return signalStoreFeature(
    withDomainState<IGtmDataModel, IGtmDataData, IGtmDataConfig>(initialState, stateConfig),
    withComputed((store) => ({
      isDefrayalFlow: computed<boolean>(() => {
        const data = store.selectData();
        return data?.isDefrayalFlow;
      }),
      isLeadFlow: computed<boolean>(() => {
        const data = store.selectData();
        return data?.isLeadFlow;
      }),
      idType: computed<string>(() => {
        const data = store.selectData();
        return data?.idType;
      })
    }))
  );
}
